import { render, staticRenderFns } from "./pricePage.vue?vue&type=template&id=00bfe6f7&scoped=true&"
import script from "./pricePage.vue?vue&type=script&lang=js&"
export * from "./pricePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bfe6f7",
  null
  
)

export default component.exports